import React, { Component } from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import CountUp from "react-countup";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import socialLinkType from "../EmployerProfile/types/socialLinkType";
import slideType from "../EmployerProfile/types/slideType";
import qualificationTechniquesType from "../AgencyProfile/types/qualificationTechniquesType";
import {
  ProfileCompletionWrapper,
  ProfileCompletionData,
  Title,
  TitleSpan,
  CloseButton,
  Subtitle,
  AddButton,
  ProgressWrapper,
  Progress,
} from "./styles/profile-completion-styles";

class ProfileCompletion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progressItems: {},
      currentPercentage: "",
      profileProgress: true,
      addText: "",
      link: "",
      animation: false,
    };
  }

  componentDidMount() {
    const { progressItems } = this.props;
    this.setState({ progressItems });
    setTimeout(() => {
      this.progress();
      this.progressAnimation();
    }, 300);
  }

  componentDidUpdate(prevProps, prevState) {
    const { progressItems } = this.props;
    if (progressItems !== prevState.progressItems) {
      this.updateProgressItems(progressItems);
    }
  }

  componentWillUnmount() {
    this.progress();
    this.progressAnimation();
  }

  updateProgressItems = (newProgressItems) => {
    this.setState({ progressItems: newProgressItems });
    this.progress();
    this.progressAnimation();
    newProgressItems.map(
      (item) =>
        (!item.data || item.data.length < 1) &&
        this.setState({ profileProgress: true })
    );
  };

  progress = () => {
    const { progressItems } = this.state;
    const amountPerItem = Math.round(100 / progressItems.length);

    const finishedFields = progressItems
      .filter((item) => item.data && item.data.length !== 0)
      .map((item) => item.name);

    const percentage = finishedFields.length * amountPerItem;
    this.setState({
      currentPercentage: percentage,
    });

    if (finishedFields.length === progressItems.length) {
      this.setState({ profileProgress: false });
    }

    const unfinishedFields = progressItems
      .filter((item) => !item.data || item.data.length === 0)
      .map((item) => item);
    const itemToAdd = unfinishedFields[0];

    if (progressItems.length - finishedFields.length === 1) {
      this.setState({
        addText: `Add <strong>${itemToAdd.name}</strong> to finish your profile`,
        link: itemToAdd.link && `${itemToAdd.link}`,
      });
    }
    if (progressItems.length - unfinishedFields.length === 0) {
      this.setState({
        addText: `Add <strong>${itemToAdd.name}</strong> for the first ${amountPerItem}%`,
        link: itemToAdd.link && `${itemToAdd.link}`,
      });
    }
    if (progressItems.length - finishedFields.length > 1) {
      this.setState({
        addText: `Add <strong>${itemToAdd.name}</strong> for another ${amountPerItem}%`,
        link: itemToAdd.link && `${itemToAdd.link}`,
      });
    }
  };

  progressAnimation = () => {
    this.setState({ animation: true });
  };

  closeButtonHandle = () => {
    this.setState({ profileProgress: false });
  };

  render() {
    const { profileProgress, addText, currentPercentage, animation, link } =
      this.state;
    const isIE = detect().name === "ie";

    const { noSlides, marginTop, mobileMargins, showAddButton } = this.props;

    if (profileProgress) {
      return (
        <ProfileCompletionWrapper>
          <ProfileCompletionData
            noSlides={noSlides}
            isIE={isIE}
            marginTop={marginTop}
            mobileMargins={mobileMargins}
          >
            <Title>
              <TitleSpan>Your profile is</TitleSpan>
              {animation ? (
                <CountUp end={currentPercentage} duration={2} />
              ) : (
                "0"
              )}
              % complete
            </Title>
            <CloseButton onClick={this.closeButtonHandle}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
            <Subtitle>{Parser(addText)}</Subtitle>
            {showAddButton && (
              <AddButton href={link} title="Add">
                Add
              </AddButton>
            )}
            <ProgressWrapper>
              <Progress
                className={animation ? "active" : null}
                progress={currentPercentage}
              />
            </ProgressWrapper>
          </ProfileCompletionData>
        </ProfileCompletionWrapper>
      );
    }
    return null;
  }
}

ProfileCompletion.propTypes = {
  progressItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({}),
        qualificationTechniquesType,
        socialLinkType,
        slideType,
      ]),
    })
  ).isRequired,
  noSlides: PropTypes.bool,
  showAddButton: PropTypes.bool,
  marginTop: PropTypes.bool,
  mobileMargins: PropTypes.bool,
};

ProfileCompletion.defaultProps = {
  marginTop: PropTypes.isNull,
  noSlides: PropTypes.isNull,
  mobileMargins: PropTypes.isNull,
  showAddButton: PropTypes.isNull,
};

export default ProfileCompletion;
